import { render } from "./UserGroupsRenderer.vue?vue&type=template&id=5217d777&scoped=true"
import script from "./UserGroupsRenderer.vue?vue&type=script&lang=js"
export * from "./UserGroupsRenderer.vue?vue&type=script&lang=js"

import "./UserGroupsRenderer.vue?vue&type=style&index=0&id=5217d777&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5217d777"]])

export default __exports__